import { useEffect, useState } from "react";
import { api, fmtINR } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const COLORS = ["#2563eb", "#16a34a", "#d97706", "#a855f7", "#dc2626"];

export default function Reports() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/summary").then((r) => setD(r.data)); }, []);
  if (!d) return <div className="text-slate-500">Loading…</div>;

  const modeData = Object.entries(d.mode_totals).map(([name, value]) => ({ name, value }));
  const branchData = d.by_branch.map((b) => ({ name: b.name, Cash: b.cash, Bank: b.bank }));

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div>
        <h1 className="text-3xl font-extrabold text-slate-900">Reports</h1>
        <p className="text-slate-500 mt-1">Analytics — payment modes, branch performance, cash flow.</p>
      </div>

      <div className="grid md:grid-cols-4 gap-4">
        <Stat label="Total Cash Collected" v={fmtINR(d.cash_collected_total)} />
        <Stat label="Total Bank Collected" v={fmtINR(d.bank_collected_total)} />
        <Stat label="Total Offloaded" v={fmtINR(d.offloaded_total)} />
        <Stat label="Current Cash in Hand" v={fmtINR(d.cash_in_hand)} highlight />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <h3 className="font-bold text-slate-800 mb-4">Collection by Payment Mode</h3>
          <div className="h-72">
            <ResponsiveContainer>
              <PieChart>
                <Pie data={modeData} dataKey="value" nameKey="name" outerRadius={100} label>
                  {modeData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip formatter={(v) => fmtINR(v)} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-slate-200 p-6">
          <h3 className="font-bold text-slate-800 mb-4">Cash vs Bank by Branch</h3>
          <div className="h-72">
            <ResponsiveContainer>
              <BarChart data={branchData}>
                <XAxis dataKey="name" fontSize={11} />
                <YAxis fontSize={11} tickFormatter={(v) => "₹" + (v / 1000) + "k"} />
                <Tooltip formatter={(v) => fmtINR(v)} />
                <Legend />
                <Bar dataKey="Cash" fill="#16a34a" radius={[6, 6, 0, 0]} />
                <Bar dataKey="Bank" fill="#2563eb" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, v, highlight }) {
  return (
    <div className={highlight ? "stat-card-primary" : "stat-card"}>
      <div className={`text-xs uppercase tracking-wider ${highlight ? "text-blue-100" : "text-slate-500"}`}>{label}</div>
      <div className={`text-xl font-extrabold mono mt-2 ${highlight ? "text-white" : "text-slate-900"}`}>{v}</div>
    </div>
  );
}
